//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


const tabs = [
    {
        key: 'business',
        name: '商业贷款'
    },
    {
        key: 'public',
        name: '公积金贷款'
    },
    {
        key: 'formalities',
        name: '还贷后手续'
    }
]
export default {
    onShareAppMessage () {
        const shareOpt = {
            title: '提前还款流程分享给你，点击查看哦~',
            path: `/pages/packageA/prepayment_calc/process`
        }
        return this.getShareInfo(shareOpt)
    },
    data () {
        return {
            tabs,
            type: 'business'
        }
    },
    methods: {
        changeType (type) {
            this.type = type
        }
    }
}
